<template>
  <div class="safe-report body">
    <el-container>
      <!-- <SafeAside /> -->

      <el-main>
        <el-row type="flex" justify="center" :gutter="10">
          <el-col :xl="16" :lg="16" :md="6" :sm="12">
            <div class="bg-White mt-2 safe-filter">
              <div class="block p-3">
                <!-- <span class="demonstration">Default</span> -->
                <el-date-picker
                  @change="getSafeReport"
                  v-model="dateRange"
                  type="daterange"
                  range-separator="  الي  "
                  format="yyyy/MM/dd"
                  value-format="yyyy-MM-dd"
                  start-placeholder="بداية الفترة"
                  end-placeholder="نهاية الفترة"
                  class="display-mobile-none"
                >
                </el-date-picker>

                <el-date-picker
                  type="date"
                  class="filter-mobile"
                  format="yyyy/MM/dd"
                  value-format="yyyy-MM-dd"
                  @change="getSafeReport"
                  v-model="startDate"
                  placeholder="Start Date"
                />
                <el-date-picker
                  type="date"
                  class="filter-mobile"
                  format="yyyy/MM/dd"
                  value-format="yyyy-MM-dd"
                  @change="getSafeReport"
                  v-model="endDate"
                  placeholder="End Date"
                />
              </div>
            </div>
          </el-col>
          <!-- <el-col class="mt-2" :xl="2" :lg="2" :md="6" :sm="12">
            <el-button
              class="mt-2"
              type="success"
              title="طباعه"
              icon="el-icon-printer"
              @click="sendToPrintAll(tableData)"
            ></el-button>
          </el-col> -->
        </el-row>
        <div class="d-flex flex-row-reverse">
          <div style="padding: 15px; background: #fff">
            <h6 class="text-center"><b>إجمالي</b></h6>
            <h6 class="mb-0">
              {{ numberToFixed(old_branch_account).toLocaleString("en-US") }}
            </h6>
          </div>
        </div>

        <el-table
          class="mt-2 table-mobile"
          align="right"
          v-if="tableData.length > 0"
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            label="#"
            type="index"
            class-name="display-mobile-none"
            width="50"
          >
          </el-table-column>
          <el-table-column
            sortable
            width="90"
            label="السند"
            prop="operation_id"
          >
            <template slot-scope="scope">
              <span class="label"> {{ scope.$index + 1 }} # السند </span>
              <div>
                {{ scope.row.operation_id }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="200" label="التوقيت" prop="donne_at">
            <template slot-scope="scope">
              <span class="label">التوقيت</span>
              <div>
                {{ scope.row.created_at | moment("Do / MM / YYYY | h:mm A") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="400" label="بيان" prop="description">
            <template slot-scope="scope">
              <span class="label">بيان</span>
              <div>{{ scope.row.description }}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column width="200" label="المستفيد" prop="for_who">
          </el-table-column> -->
          <el-table-column label="دائن">
            <template slot-scope="scope">
              <span class="label">دائن</span>
              <div>
                <span v-if="scope.row.transaction_type == 1">
                  <span v-if="scope.row.amount">
                    <!-- {{ (scope.row.amount).toLocaleString('en-US') }} -->
                    {{
                      numberToFixed(scope.row.amount).toLocaleString("en-US")
                    }}
                  </span>
                </span>
                <span v-else></span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label=" مدين">
            <template slot-scope="scope">
              <span class="label">مدين</span>
              <div>
                <span v-if="scope.row.transaction_type == 0">
                  <span v-if="scope.row.amount">
                    <!-- {{ (scope.row.amount).toLocaleString('en-US') }} -->
                    {{
                      numberToFixed(scope.row.amount).toLocaleString("en-US")
                    }}
                  </span>
                </span>
                <span v-else></span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="الرصيد">
            <template slot-scope="scope">
              <span class="label">الرصيد</span>
              <div>
                {{ numberToFixed(scope.row.account).toLocaleString("en-US") }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>
<script>
// import SafeAside from "@/components/SafeAside.vue";
import axiosApi from "@/plugins/axios.js";
// import { ipcRenderer } from "electron";

export default {
  name: "CustomerReport",
  // components: { SafeAside },
  data() {
    return {
      false: false,
      true: true,
      dateRange: null,
      tableData: [],
      old_branch_account: 0,
      startDate: "",
      endDate: "",
    };
  },
  created() {
    this.getSafeReport();
    // axiosApi("safe/transactions")
    //   .then((res) => {
    //     console.log(res);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  },

  methods: {
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    getSafeReport() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let url = `safe/transactions`;
      if (this.dateRange != null) {
        url += `?start=${this.dateRange[0]}`;
        url += `&end=${this.dateRange[1]}`;
      }
      if (this.startDate) {
        url += `?start=${this.startDate}`;
      }
      if (this.endDate) {
        url += `?end=${this.endDate}`;
      }

      this.tableData = [];

      axiosApi
        .get(url)
        .then((response) => {
          // console.log(response.data)
          this.tableData = response.data.safeTransaction;
          // console.log("old_branch_account", response.data.old_branch_account);
          this.old_branch_account = Number(response.data.safe.balance);
          let sum = Number(response.data.old);
          let inCash = Number(response.data.old);
          let outCash = 0;
          if (response.data.safeTransaction.length > 0) {
            this.tableData.map(function (value) {
              if (value["transaction_type"] == 1) {
                sum += Number(value["amount"]);
                inCash += Number(value["amount"]);
              } else {
                sum -= Number(value["amount"]);
                outCash += Number(value["amount"]);
              }

              value["account"] = sum;
            });
          }
          this.inCashDrawer = inCash;
          this.outCashDrawer = outCash;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
        });
    },
    sendToPrintAll(tableData) {
      // window.ipcRenderer = ipcRenderer;
      let data = {
        data: tableData,
        type: "Safe",
        dateRange: this.dateRange,
        title: "الخزينه",
        img:
          "https://pos.staging.fatura-app.com" +
          JSON.parse(localStorage.getItem("branch")).logo,
      };
      // ipcRenderer.send("printing", data);
      console.log(data);
    },
  },
};
</script>

<style scoped>
.el-table {
  width: 100%;
  max-height: 88.5%;
  overflow-y: scroll;
}
</style>
